import React from 'react'
import { Box, SwxTheme } from 'swx-atomic-component-lib'
import InformationIcon from 'calcite-ui-icons-react/InformationIcon'
import profileStyles from './profileStyles'
import passwordCriteriaFunc from './PasswordStrength.utils'

function PasswordStrengthMeter (props) {
  const { password, score, zxcvbnResult, meterHolderStyle, strengthMeterStyle, minScore } = props
  const { dataStrength, passResult, allSuggestions, suggestionResult } = passwordCriteriaFunc({ zxcvbnResult, password, score, minScore })

  const suggestionListStyle = { marginTop: '0px' }

  return (
    <Box customStyle={meterHolderStyle ? profileStyles.passwordStrengthMeterHolder.concat(meterHolderStyle) : profileStyles.passwordStrengthMeterHolder} className='mobile-zero-padding'>
      <Box customStyle={strengthMeterStyle ? profileStyles.passwordStrengthMeter.concat(strengthMeterStyle) : profileStyles.passwordStrengthMeter} className='mobile-full-width'>
        <Box customStyle={profileStyles.strengthMeter}>
          <Box customStyle={profileStyles.strengthMeterFill} data-strength={dataStrength} />
        </Box>
        <Box customStyle='display: flex;'>
          <Box customStyle={profileStyles.weakDiv}>Weak</Box><Box customStyle={profileStyles.strongDiv}>Strong</Box>
        </Box>
      </Box>
      {
        dataStrength >= 0 && (
          <Box customStyle={profileStyles.passwordStrengthMeterResult}>
            <Box customStyle={profileStyles.passwordStrengthMeterTooltip}><InformationIcon filled size={16} color={SwxTheme.palette['secondary-dark']} /></Box>
            <Box customStyle='display: inline-block;'>
              <Box>{passResult}</Box>
              <Box>
                {suggestionResult}
                <ul style={suggestionListStyle}>{allSuggestions.map((li, i) => <li key={i}>{li}</li>)}</ul>
              </Box>
            </Box>
          </Box>
        )
      }

    </Box>
  )
}

export default PasswordStrengthMeter
